module.exports = __webpack_public_path__ + "02_short_gray.2f3e3ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/02_short_gray.png
// module id = QUn9
// module chunks = 0